// @flow

import { default as FormLabel } from './FormLabel';
export default FormLabel;
export { default as FormLabelRequiredText } from './FormLabelRequiredText';
